export default "__VITE_ASSET__Cqh98HJx__"